module.exports = "\u0002�RCopyright 1990-2009 Adobe Systems Incorporated.\nAll rights reserved.\nSee ./LICENSE\u0000\u0001\u0000�`\u0001 ^�g"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/pdfjs-dist/cmaps/Roman.bcmap
// module id = 1109
// module chunks = 50